import GameComponent from '../components/GameComponent';

function Game() {
  return (
    <div className="Game-container">
      <div>
        <GameComponent /> {/* Component game */}
      </div>
    </div>
  );
}

export default Game;
